<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob"></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <!--<div class="logo_form"> <img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt=""> </div>-->
          <div class="form_title">
            <h1>{{ getTranslations.visitor_forgot_password_3_almost_done_msg }}</h1>
          </div>
          </div>
          <div class="col-lg-12">
            <div class="twoStepRegSteps_Container">
              <div class="twoStepRegSteps_step step_done">1</div>
              <div class="twoStepRegSteps_step">2</div>
            </div>
          </div>
          <div class="form-help extra_padng">
            <p>{{ getTranslations.visitor_forgot_password_3_create_pin_or_fb }}</p>
          </div>
            <form action="">
              <p v-if="facebookFunctionality && !isHomeMode()"></p>
              <div v-if="facebookFunctionality && !isHomeMode()"
                   class="form-group form-group--icon fb_login"
                   :class="[ !errorInFb? '' : 'has-warning' ]">
                <facebook-login :enteredUsername="'User'"
                                :type="fbActionType"
                                @errorsUpdated="methodForEvent($event)">
                </facebook-login>
                <span v-if="facebookFunctionality && errorInFb"
                      class="form-group__feedback">{{ getMessage(errorInFb) }}
                </span>
              </div>
              <div v-if="facebookFunctionality && !isHomeMode()"
                   class="form-group form-group--or">
                <div><span>{{ getTranslations.visitor_sign_up_and_login_or }}</span></div>
              </div>
              <div :class="[ 'form-group form-group--icon', !hasErrorsPassword ? '' : 'has-warning' ]">
                <input type="password"
                       :class="[ 'password form-group__textfield', !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_enter_password"
                       @keyup="checkPassword"
                       v-model="user.password" />
                <span v-show="getMessage(messageForPassword) && user.password"
                      class="form-group__feedback">
                 {{ getMessage(messageForPassword) }}
                </span>
              </div>
              <div :class="[ 'form-group form-group--icon', !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
                <input type="password"
                       :class="[ 'password form-group__textfield', !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_confirm_password_placeholder"
                       @keyup="checkConfirmation"
                       v-model="user.confirmPassword" />
                <span v-show="getMessage(messageForConfirmPassword) && user.confirmPassword"
                      class="form-group__feedback">{{ getMessage(messageForConfirmPassword) }}</span>
              </div>
              <input type="submit"
                     :value="getTranslations.visitor_forgot_password_3_reset_password"
                     :class="['btn btn--medium btn--main', ( hasErrorsUsername || hasErrorsPassword || hasErrorsConfirmPassword)? 'deactivated' : '']"
                     @click.prevent="checkButton">
              <div class="form-footer"></div>

            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import FacebookLogin from '.././FacebookLogin';

export default {
  name: 'twoStepForgotPassword2',
  components: { FacebookLogin },
  data() {
    return {
      errorInFb: null,
      fbActionType: 'login',
      user: {
        password: '',
        confirmPassword: '',
      },
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      message: '',
      checkedRememberMe: true,
    };
  },
  methods: {
    ...mapActions('profile', [
      'callForAuthorization',
      'resetPassword',
      'getUserLoginDetails',
    ]),
    isHomeMode() {
      return this.$route.path.includes('home');
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    clearData() {
      this.change();
      this.user.password = '';
      this.user.confirmPassword = '';
      this.messageForPassword = '';
      this.messageForConfirmPassword = '';
      this.hasErrorsPassword = false;
      this.hasErrorsConfirmPassword = false;
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          // Maximum exceeded
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkConfirmation(evt) {
      this.messageForConfirmPassword = '';
      const min = 4;
      const max = 4;
      // eslint-disable-next-line
      const validPasswordRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validUsername = this.user.confirmPassword.match(validPasswordRegex);
      this.hasErrorsConfirmPassword = false;
      if (this.user.confirmPassword.length < min) {
        this.messageForConfirmPassword = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsConfirmPassword = true;
      } else if (this.user.confirmPassword.length > max) {
        this.user.confirmPassword = this.checkMaxChar(this.user.confirmPassword, max, evt);
        this.hasErrorsConfirmPassword = true;
        this.checkConfirmation();
      } else if (validUsername !== null) {
        if (this.user.confirmPassword.length > max) {
          this.user.confirmPassword = this.checkMaxChar(this.user.confirmPassword, max, evt);
          this.hasErrorsConfirmPassword = true;
        }
        this.messageForConfirmPassword = '';
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_forgot_password_3_entered_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validUsername === null) {
        this.hasErrorsConfirmPassword = true;
        // eslint-disable-next-line
        this.messageForConfirmPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
    },
    checkPassword(evt) {
      this.messageForUsername = '';
      const min = 4;
      const max = 4;
      // eslint-disable-next-line
      const validPasswordRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validUsername = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;

      if (this.user.password.length < min) {
        this.messageForPassword = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsPassword = true;
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validUsername !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_forgot_password_3_entered_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validUsername === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
//      if (this.hasErrorsPassword && this.user.password.length >= min) {
//        const passwordWithoutLetter = this.user.password.match(/^(?!.*[A-Za-z]).+$/);
//        const passwordWithoutNumber = this.user.password.match(/^(?!.*\d).+$/);
//        const passwordWithSymbolsExceptUnderscore = this.user.password.match(/^(?!.*\W)_?.+$/);
//        if (passwordWithoutLetter !== null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_does_not_contain_at_least_one_letter;
//        } else if (passwordWithoutNumber !== null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_does_not_contain_at_least_one_1_digit;
//        } else if (passwordWithSymbolsExceptUnderscore === null) {
//          // eslint-disable-next-line
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_;
//        }
//      }
    },
    change() {
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
    },
    checkButton() {
      if (this.hasErrorsPassword || this.hasErrorsConfirmPassword || this.user.password === '' || this.user.confirmPassword === '') {
        this.message = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrors = true;
      } else {
        // eslint-disable-next-line
        if (this.hasErrorsPassword === '') {
          this.message = 'User Refreshed the page!! Try again from step1';
          this.hasErrors = true;
        } else {
          const userData = {
            msisdn: this.forgotPasswordInfo,
            password: this.user.confirmPassword,
          };
          this.resetPassword(userData).then(() => {
            const userDataforAuthorization = {
              username: this.forgotPasswordInfo,
              password: this.user.confirmPassword,
              rememberMe: this.checkedRememberMe,
            };
            this.callForAuthorization(userDataforAuthorization).then(() => {
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  this.hasErrors = false;
                  this.$router.push('/home');
                });
              } else {
                this.message = 'visitor_forgot_password_3_password_6_char_long';
                this.hasErrors = true;
              }
            });
          });
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
    ]),
    ...mapState('profile', [
      'forgotPasswordInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/TwoStepForgotPassword2.vue